export const WOO_PLATFORM_ID = 2
export const TIME_REQUEST = 5000
